import { createAsyncThunk } from '@reduxjs/toolkit'
import { fetchTriggeredExecutions, fetchExecutionDetail } from '../api'
import { TriggeredExecutionSummary, ExecutionDetailResponse } from '../types/TriggeredExecution'
import { ScriptFeedbackStep } from '../../mScripts/tessaScript/types/ScriptExecution'

export const getTriggeredExecutions = createAsyncThunk<
  TriggeredExecutionSummary[],
  { robotId: number; from: string; to: string; limit?: number }
>(
  'triggeredExecutions/getTriggeredExecutions',
  async ({ robotId, from, to, limit }) => {
    const { data } = await fetchTriggeredExecutions(robotId, from, to, limit)
    return data.triggeredExecutions
  }
)

export const getExecutionDetail = createAsyncThunk<
  ExecutionDetailResponse & { scriptFeedbackSteps: ScriptFeedbackStep[] },
  { robotId: number; executionId: number }
>(
  'triggeredExecutions/getExecutionDetail',
  async ({ robotId, executionId }) => {
    const { data } = await fetchExecutionDetail(robotId, executionId)
    return data
  }
)
